const HASH_ALGORITHM = 'SHA-256';

/**
 * Hashes input string using SHA-256 and returns hex-encoded result
 * @param {string} input - The string to hash
 * @returns {Promise<string>} - The hex-encoded hash
 */
const createHash = async (input) => {
    // Convert string to ArrayBuffer
    const encoder = new TextEncoder();
    const data = encoder.encode(input);

    // Hash the data using Web Crypto API
    const hashBuffer = await crypto.subtle.digest(HASH_ALGORITHM, data);

    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export default createHash;

